import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loading from "../components/Loading/index.js";

import AdminShell from "components/Shell/AdminShell.js";
import routes from "routes.js";

import "styles/lukos-shell.css";

export default function Admin() {
  // Guarda de sessão — sem token, volta para o login.
  const [isLogged, setIsLogged] = React.useState(() => {
    return !!localStorage.getItem("lukos-token-fw");
  });

  React.useEffect(() => {
    const token = localStorage.getItem("lukos-token-fw");
    if (!token) {
      window.location.href = "/auth/login-page";
    } else {
      setIsLogged(true);
    }
  }, []);

  if (!isLogged) {
    return null;
  }

  const getRoutes = (allRoutes) => {
    return allRoutes
      .map((prop, key) => {
        if (prop.collapse) {
          return getRoutes(prop.views);
        }
        if (prop.layout !== "/admin") {
          return null;
        }
        const Component = prop.component;
        return (
          <Route
            key={key}
            // path relativo ao "/admin/*" definido no index.js
            path={prop.path.replace(/^\//, "")}
            element={
              <Suspense fallback={<Loading fullScreen />}>
                <Component />
              </Suspense>
            }
          />
        );
      })
      .flat();
  };

  return (
    <AdminShell>
      <Routes>
        {getRoutes(routes)}
        <Route index element={<Navigate to="dashboard" replace />} />
      </Routes>
    </AdminShell>
  );
}
